export class RechazarEvaluacion{
    ID_evaluado:number;
    motivoInactivacion:string;
    ID_evaluador:number;
    ID_revisor:number;
}